import React from 'react';

import { DownIcon, HikeIcon } from '../Survey/Assets';
const images = require.context('../../Assets/emoji', true);
const TeamReport = () => {
  const emoji = images(`./Emoji1.svg`);
  return (
    <div className="team-report">
      <div className="team-header">
        <h4>Team Report</h4>
        <p>Last Month</p>
      </div>
      <div className="team-info">
        <div className="row">
          <div className="col mb-3 card-main">
            <div className="h-100 custom-box">
              <h6>Team Engagement</h6>
              <div className="icon-wrap">
                <img src={emoji} alt="emoji" />
              </div>
              <div className="report-chart">
                <h4>
                  83%{' '}
                  <span>
                    {' '}
                    <HikeIcon />{' '}
                  </span>
                </h4>
                <h5>Satisfied</h5>
              </div>
            </div>
          </div>
          <div className="col mb-3 card-main">
            <div className="h-100 custom-box">
              <h6>Team Satisfaction</h6>
              <div className="icon-wrap">
                <img src={emoji} alt="emoji" />
              </div>
              <div className="report-chart">
                <h4>
                  83%{' '}
                  <span>
                    {' '}
                    <DownIcon />
                  </span>
                </h4>
                <h5>Satisfied</h5>
              </div>
            </div>
          </div>
          <div className="col mb-3 card-main">
            <div className="h-100 custom-box">
              <h6>Team Return</h6>
              <div className="report-chart mb-3 mt-3">
                <h2>
                  75{' '}
                  <span>
                    {' '}
                    <HikeIcon />
                  </span>
                </h2>
                <h5>Hours Saved</h5>
              </div>
              <div className="report-chart">
                <h2>
                  107%
                  <span>
                    {' '}
                    <HikeIcon />
                  </span>
                </h2>
                <h5>Productivity</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamReport;
